import router from '../../router'
import { isTenant, sanitizeTenantId } from '../../helpers/general'

export async function signIn({ dispatch, commit }, credentials) {
  try {
    // Get CSRF cookie
    await axios.get('csrf-cookie')

    // Perform login request
    const response = await axios.post('/api/login', credentials)
    const responseData = response.data;

    // Log for debugging
    console.log('Login response in action:', responseData);

    // Immediately commit tenants to store
    if (responseData.data?.tenants) {
      commit('SET_TENANTS', responseData.data.tenants);
    }

    // Set user data if available
    if (responseData.data?.user) {
      commit('SET_USER', responseData.data.user);
      commit('SET_AUTHENTICATED', true);
    }

    return responseData;
  } catch (error) {
    console.error('Login error in action:', error);
    // Ensure we're returning a consistent error format
    return Promise.reject(error.response?.data || {
      message: error.message || 'Login failed'
    });
  }
}

export async function selectTenant({ dispatch, commit }, tenantId) {
  try {
    console.log('Selecting tenant:', tenantId);

    // Set tenant header for all future requests
    axios.defaults.headers.common['X-Tenant-ID'] = tenantId;

    // Store tenant ID
    localStorage.setItem('tenant', tenantId);

    // Update store
    commit('SET_SELECTED_TENANT', tenantId);

    // Get the current domain parts
    const currentHost = window.location.host;
    const domain = import.meta.env.VITE_CENTRAL_DOMAIN;
    const isCentralDomain = currentHost === domain;
    const currentTenantDomain = `${tenantId}.${domain}`;
    // Only redirect if we're on central domain or wrong tenant domain
      if (tenantId === 'central') {
          return Promise.resolve(true);
      }
    if (isCentralDomain || currentHost !== currentTenantDomain) {
      // Ensure cookies are available before redirect
      // await dispatch('me');
      window.location.href = `https://${sanitizeTenantId(currentTenantDomain)}?tenant=${tenantId}`;
      return;
    }

    return Promise.resolve(true);
  } catch (error) {
    console.error('Tenant selection error:', error);
    return Promise.reject(error);
  }
}

export async function signUp({ dispatch, commit }, credentials) {
  try {
    const request = await axios.post('/api/register', credentials)
    const token = request.data.data.token
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
    return request.data
  } catch (e) {
    return Promise.reject(e.response.data)
  }
}

export async function forgottenPassword({ commit }, credentials) {
  try {
    const request = await axios.get('/api/forgot-password', { params: credentials })
    return request.data
  } catch (e) {
    console.log(e)
    return Promise.reject(e.response.data)
  }
}

export async function resetPassword({ commit }, credentials) {
  try {
    const request = await axios.post('/api/reset-password', credentials)
    return request.data
  } catch (e) {
    return Promise.reject(e.response.data)
  }
}

export async function signOut({ dispatch, commit }) {
  localStorage.removeItem('token')
  localStorage.removeItem('tenant')
  localStorage.removeItem('refresh_token')
  axios.defaults.headers.common.Authorization = ''
  await axios.get('/api/logout')
  commit('SET_AUTHENTICATED', false)
  commit('SET_USER', null)
  commit('SET_SELECTED_TENANT', null)
  commit('SET_TOKEN', null)
  window.location.href = `https://${import.meta.env.VITE_CENTRAL_DOMAIN}/auth/logout`;
  //   if (isTenant()) {
  //   } else {
  //     router.push({ path: '/auth/logout' })
  //   }
  // return dispatch('me')
}

export async function me({ commit }) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const tenantUrl = urlParams.get('tenant');
    const storedTenant = localStorage.getItem('tenant');
    const tenant = tenantUrl ?? storedTenant;

    if (tenant) {
      axios.defaults.headers.common['X-Tenant-ID'] = tenant;
    }
    const request = await axios.get('/api/user');

    if (request.data) {
      commit('SET_AUTHENTICATED', true);
      commit('SET_USER', request.data);
      if (request.data.user_settings?.language) {
        commit('SET_USER_LANGUAGE', request.data.user_settings.language);
      }
    }

    return Promise.resolve(true);
  } catch (error) {
    console.error('Me endpoint error:', error);

    // If unauthorized or forbidden, redirect to central login
    if (error.response?.status === 401) {
      localStorage.removeItem('tenant');
      delete axios.defaults.headers.common['X-Tenant-ID'];
      commit('SET_SELECTED_TENANT', null);
      commit('SET_AUTHENTICATED', false);
      commit('SET_USER', null);

      const centralDomain = import.meta.env.VITE_CENTRAL_DOMAIN;
      if (window.location.host !== centralDomain) {
        window.location.href = `https://${centralDomain}/auth/login`;
        return;
      }
    }

    return Promise.reject(error);
  }
}
